import React from "react";
import * as Preloader from "../../../../../../common-deprecated/styles/v2/toyota/custom/Preloader";
import * as Styles from "./styles/ModelResultStyles";
import { useModelFilterSelector } from "../../../redux/store";
import ModelResult from "./ModelResult";
import NoResults from "./NoResults";
import ComingSoonBlock from "./ComingSoonBlock";
import SrOnly, { SkipLink } from "../../../../../../common-deprecated/styles/v2/toyota/utilities/ScreenreaderOnly";
import FilterResultCount from "../active-filters/top-bar/FilterResultCount";
import { showComingSoon } from "../../../utils/helpers";
import { ModelFilterLabel } from "../../../utils/labels";
import { SKIP_ID_FILTERS, SKIP_ID_RESULTS } from "../../../utils/constants/constants";

const ModelResultsContainer = (): JSX.Element => {
    const initialized = useModelFilterSelector((state) => state.modelResults.initialized);
    const results = useModelFilterSelector((state) => state.modelResults.results);
    const commonSettings = useModelFilterSelector((state) => state.commonSettings);
    const comingSoonBlockConfig = useModelFilterSelector(
        (state) => state.modelFilterSettings.comingSoonBlockConfigurations,
    );

    const resultComponent = results.map((model) => (
        <ModelResult
            // eslint-disable-next-line react/no-array-index-key
            key={model.id}
            model={model}
            data-testid="modelresult"
        />
    ));

    if (comingSoonBlockConfig && showComingSoon(commonSettings, results)) {
        comingSoonBlockConfig.forEach((config, index) => {
            resultComponent.splice(
                config.position - 1,
                0,
                <ComingSoonBlock
                    comingSoonBlockConfig={config}
                    // eslint-disable-next-line react/no-array-index-key
                    key={`${index}`}
                />,
            );
        });
    }

    return (
        // Note, this Id is used for a skip link
        <Styles.Grid id={SKIP_ID_RESULTS}>
            {initialized ? (
                <>
                    {/* Gives an additional sr-only text to amount of results after tabbing away from the sidebar */}
                    <SrOnly>
                        <FilterResultCount show={false} sruAccessible={0} />
                    </SrOnly>
                    {resultComponent}
                    {!results.length && <NoResults />}
                </>
            ) : (
                <Preloader.Wrapper width={1} position="relative">
                    <Preloader.default data-testid="preloader" />
                </Preloader.Wrapper>
            )}

            <SkipLink href={`#${SKIP_ID_FILTERS}`}>
                <ModelFilterLabel label="modelfilterA11yButtonReturnToFilters" />
            </SkipLink>
        </Styles.Grid>
    );
};

export default ModelResultsContainer;
